import { Fields } from '@app/sharedModule/components/rules-dynamic-form/model';
import { RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';

export const DeliveryPromiseRestrictionRules = [
  {
    entity: RuleEntity.ARRIVAL_DATE,
    entityOperator: null,
    entityParams: [
      {
        name: 'prefix',
        defaultValue: 'is more than',
        fieldType: Fields.TEXT,
      },
      {
        required: true,
        name: 'arrivalDateValue',
        defaultValue: '',
        min: 0,
        fieldType: Fields.ARROW_INPUT,
      },
      {
        name: 'suffix',
        defaultValue: 'calendar days away',
        fieldType: Fields.TEXT,
      },
    ],
  },
  {
    entity: RuleEntity.UNFULFILLED_ORDERS,
    entityOperator: null,
    entityParams: [
      {
        name: 'prefix',
        defaultValue: 'in',
        fieldType: Fields.TEXT,
      },
      {
        required: true,
        name: 'locationIdsValue',
        placeholder: 'Select warehouse',
        defaultValue: '',
        options: [],
        fieldType: Fields.CHECKBOX_LIST,
      },
      {
        name: 'middle',
        defaultValue: 'is more than',
        fieldType: Fields.TEXT,
      },
      {
        required: true,
        name: 'unfulfilledOrdersValue',
        defaultValue: '',
        min: 0,
        fieldType: Fields.ARROW_INPUT,
      },
    ],
  },
];
